import styled from 'styled-components';

import BiddingList from './component';

const StyledBiddingList = styled(BiddingList)`
  color: #fff;

  ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
  }

  .not_viewed {
    display: block;
    width: 10px;
    height: 10px;
    background: red;
    border-radius: 10px;
    margin-right: 4px;
  }

  .loading {
    display: block;
    margin: 1.6rem auto 0 auto;
  }

  .zero-results {
    margin: 1.6rem auto;
    text-align: center;
  }

  .list_item_container {
    display: table;
    width: 100%;
  }

  .list_item_header.list_item_header {
    color: var(--grey500);
    height: 20px;
    &:hover {
      background-color: transparent;
    }
    > div {
      border-bottom: 1px solid var(--grey700);
    }
  }

  .name_content {
    display: flex;
    align-items: center;
  }

  .list_item,
  .list_item_header {
    display: table-row;
    padding: 0 0.8rem;

    &[disabled] {
      opacity: 0.5;
    }

    &:hover {
      background-color: var(--grey900);
    }

    & > div {
      display: table-cell;
      padding: 0.8rem;
      vertical-align: middle;
    }

    .name {
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      max-width: 120px;
    }

    .bid,
    .scoring {
      text-align: right;
    }
  }

  &.success {
    color: var(--grey900);
    margin: 0.8rem;
  }

  .error {
    color: var(--grey900);
    margin: 0.8rem;
  }

  .actions {
    color: #fff;
    width: 24px;
    height: 24px;
    border: 1px solid white;
    background: transparent;
    border-radius: 4px;
    cursor: pointer;
    outline: none;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    -webkit-appearance: none;
    padding: 0 0 0 0;

    & > svg {
      margin-top: 3px;
    }
  }

  .tooltip_container {
    background-color: white;
    border-radius: 8px;
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.2);
    opacity: 1;
    padding: 0;
    overflow: hidden;

    .action_button {
      background-color: white;
      height: 36px;
      text-decoration: none;
      cursor: pointer;
      outline: none;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      -webkit-appearance: none;
      color: var(--grey900);
      border: 0;
      width: 100%;
      padding: 0 1.6rem;
      &:hover {
        background: var(--primary100);
      }
    }
  }
`;

export default StyledBiddingList;
